var _g, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSimplifiedIssue24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ic.Simplified Issue.24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11236",
    fill: "none",
    stroke: "#197aba",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10890",
    d: "M10 6.6H5.8A1.8 1.8 0 004 8.395v10.811A1.8 1.8 0 005.8 21h7.147a1.8 1.8 0 001.8-1.8v-.763"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10891",
    d: "M9.3 16.976l6.5 1.754a2 2 0 002.453-1.416l2.68-10.044a2.008 2.008 0 00-1.412-2.446L13.012 3.07a2 2 0 00-2.453 1.416L7.883 14.53A2 2 0 009.3 16.976z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10892",
    d: "M11.4 17.54l3.72-13.9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10893",
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}

export default SvgSimplifiedIssue24;


//////////////////
// WEBPACK FOOTER
// ./src/icons/simplifiedIssue.24.svg
// module id = 873
// module chunks = 101